var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { isFunction, isPromise } from '@vue/shared';
export function callWithErrorHandling(fn, type, args) {
    var res;
    try {
        res = args ? fn.apply(void 0, __spreadArray([], __read(args))) : fn();
    }
    catch (err) {
        handleError(err, type);
    }
    return res;
}
export function callWithAsyncErrorHandling(fn, type, args) {
    if (isFunction(fn)) {
        var res = callWithErrorHandling(fn, type, args);
        if (res && isPromise(res)) {
            res.catch(function (err) {
                handleError(err, type);
            });
        }
        return res;
    }
    var values = [];
    for (var i = 0; i < fn.length; i++)
        values.push(callWithAsyncErrorHandling(fn[i], type, args));
    return values;
}
export function handleError(err, type) {
    console.error(new Error("[@vue-reactivity/watch]: " + type));
    console.error(err);
}
export function raise(message) {
    throw createError(message);
}
export function warn(message) {
    console.warn(createError(message));
}
export function createError(message) {
    return new Error("[reactivue]: " + message);
}
